import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Usuario } from '@app/_models';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { NumericFilterCellComponent } from '@progress/kendo-angular-grid';

const baseUrl = `${environment.apiUrl}/grupos`;

@Injectable()
export class GruposService {

  constructor(private http: HttpClient) { }

  public GetAll(): Observable<any> {
    return this.http.get(baseUrl);
  }

  public GetById(id: Number): Observable<any> {
    return this.http.get(baseUrl + "/" + id);
  }

  public GetUsersGrupo(codgrupo: Number): Observable<any> {
    return this.http.get(baseUrl + "/usGrupo/" + codgrupo);
  }

  public GetUsersNoGrupo(codgrupo: Number): Observable<any> {
    return this.http.get(baseUrl + "/usNoGrupo/" + codgrupo);
  }

  insert(data) {
    return this.http.post<any>(baseUrl + "/crear", { codigo: -1, codigoUsuario: data.codigoUsuario, nombre: data.nombre, 
      grupo_cods: data.grupo_cods, nogrupo_cods: data.nogrupo_cods }, { withCredentials: true });
  }

  update(data) {
    //console.log(JSON.stringify(data));
    //console.log(idTipoPerdida_DAT);
    return this.http.post<any>(baseUrl + "/editar", { codigo: data.codigo, codigoUsuario: data.codigoUsuario, nombre: data.nombre, 
      grupo_cods: data.grupo_cods, nogrupo_cods: data.nogrupo_cods }, { withCredentials: true });
  }

  delete(data?: any): Observable<any> {

    //console.log(JSON.stringify(data));
    var formData: any = new FormData();
    formData.append("codigos", data.codigos);
    //console.log(JSON.stringify(formData));

    return this.http.post<JSON>(baseUrl + "/eliminar", formData, { withCredentials: true });
  }

}
